import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import ionMenu from "../../../assets/img/Langding/ionMenu.svg";
import ionMenuClose from "../../../assets/img/Langding/ionMenuClose.svg";

export const Wapper = styled(Box)<{ BgColor?: string }>`
  padding: 33px 4vw;
  width: 100%;
  max-width: 1920px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 50%;
  min-height: 56px;
  transform: translateX(-50%);
  z-index: 999;
  background-color: ${({ BgColor }) => (BgColor ? BgColor : "")};
  transition: background-color 0.2s linear;
  @media only screen and (min-width: 1920px) {
    padding: 33px 80px;
  }
  @media only screen and (max-width: 1024px) {
    img {
      width: 15.42vw;
      min-width: 66px;
    }
  }
`;
export const ContainerList = styled(Box)`
  width: calc(100% - 180px);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 3.6vw;
  button {
    background-color: transparent;
    border: none;
    outline: none;
    color: #fff;
    font-weight: 600;
    font-size: 18px;
    line-height: 110%;
    font-family: PoppinsSemiBold;
    transition: all 0.2s linear;
    :hover {
      color: #ffb536;
    }
  }
  a {
    :last-child {
      button {
        width: 197px;
        height: 48px;
        background: #ffb536;
        box-shadow: 2px 4px 6px rgba(15, 46, 57, 0.23);
        border-radius: 10px;
        transition: color 0.2s linear;
        :hover {
          color: #fff;
        }
        :active {
          transform: translateY(3%);
        }
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    a {
      display: none;
    }
  }
`;

export const ListMobile = styled.div<{ ShowMenu?: boolean }>`
  display: none;
  @media only screen and (max-width: 1024px) {
    display: flex;
    align-items: center;
    position: relative;
    button {
      width: 5.6vw;
      height: 5.6vw;
      min-width: 24px;
      min-height: 24px;
      background-color: transparent;
      border: none;
      outline: none;
      background-image: url("${({ ShowMenu }) =>
        ShowMenu ? ionMenuClose : ionMenu}");
      background-repeat: no-repeat;
      background-size: cover;
      transition: all 0.2s linear;
    }
  }
`;
export const MobileContent = styled(Box)<{ ShowMenu?: boolean }>`
  width: 149px;
  height: ${({ ShowMenu }) => (ShowMenu ? "211px" : "0px")};
  background-color: #fff;
  border-radius: ${({ ShowMenu }) => (ShowMenu ? "0px 30px" : "0px")};
  position: absolute;
  right: 0;
  bottom: 0;
  transform: translateY(100%);
  transition: all 0.2s linear;
  padding: ${({ ShowMenu }) => (ShowMenu ? "20px" : "0px")};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  button {
    background-color: transparent;
    background-image: none;
    width: fit-content;
    min-height: 13px;
    height: 100%;
  }
  a {
    width: 100%;
    height: 13px;
    padding: 0px;
    margin-bottom: 20px;
    color: #3d4856;
    font-weight: 500;
    font-size: 12px;
    line-height: 110%;
    text-align: flex-start;
    :hover{
      button{
        color: #FFB536;
      }
    }
    :last-child {
      margin-bottom: 0px;
      height: 27px;
      box-shadow: 2px 4px 6px rgba(15, 46, 57, 0.23);
      border-radius: 5px;
      background: #FFB536;
      button{
        width: 100%;
        height: 100%;
        color: #fff;
      }
    }
  }
`;
